import React from "react";
import { Modal, ModalBody } from "reactstrap";
import "./style.css";

const MessageModal = ({ message, isModalOpen, closeModal }) => {
  return (
    <Modal
      className="editTemplate-adminConfirmation-popup-modal"
      isOpen={isModalOpen}
      backdrop
      keyboard={false}
      wrapClassName="modal-primary"
      size="lg"
    >
      <div className="modal-title-color editTemplateDetails-modal-title">
        <h5>
          <strong>Message from the server</strong>
        </h5>
      </div>
      <ModalBody>
        <div className="editTemplate-adminConfirmationModal-modal-body-content">
          <strong>{message}</strong>
          <div className="editTemplate-adminConfirmationModal-popup-button">
            <button
              type="button"
              onClick={closeModal}
              className="btn btn-primary editTemplate-adminConfirmationModal-button btn-rounded"
            >
              Close
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default MessageModal;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Content Management/MessageModal.js